// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";

export const createPOA = async ({
  signedData,
  email,
  validFrom,
  validTo,
  credentials,
}: {
  signedData: object;
  email: string;
  validFrom: string;
  validTo: string;
  credentials: object;
}) => {
  const poaObject = {
    additionalData: {
      email,
      validFrom,
      validTo,
      fid: credentials.identityId,
    },
    ...signedData,
  };
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/fmk/store`,
    credentials,
    { "content-type": "application/json" },
    poaObject
  );

  const response = await apiClient({
    url: `/fmk/store`,
    method: "POST",
    headers: signedRequest.options.headers,
    data: signedRequest.options.body,
  });
  return response.data;
};

export const useCreatePOA = () =>
  useMutation({
    mutationFn: ({
      signedData,
      email,
      validFrom,
      validTo,
      credentials,
    }: {
      signedData: unknown;
      email: string;
      validFrom: string;
      validTo: unknown;
      credentials: unknown;
    }) =>
      createPOA({
        signedData,
        email,
        validFrom,
        validTo,
        credentials,
      }),
  });
